import { apiProvider } from './api';
import { NAME } from './constants';
import { router } from './router';

export const RezervaceND = {
	name: NAME,
	apiProvider,
	router,
};
